import React from 'react';

import CoreAccordionGroup from 'brandComponents/core/AccordionGroup';

import {IAccordionGroupProps} from './IAccordionGroup';

const AccordionGroup = (props: IAccordionGroupProps) => {

	return (
		<CoreAccordionGroup {...props} />
	);
};

export default AccordionGroup;
